import BaseService from './BaseService';

class PaymentService extends BaseService {

  constructor(){
    super();
    this.serviceUrl = "/api/rest";
  }


  listByCustomerAccount(ca) {
    let url = this.serviceUrl + '/payment/customerPayment?customerAccountCode=' + ca.code;
    return this.opencellAPI.callApi(url);
  }

  createNewPayment(info ){
	let url = this.serviceUrl;
	return this.opencellAPI.invokeRequest(info, url, "POST");
  }

  validate(iban) {
		// let url = this.serviceUrl + `/iban/validate?iban=${iban}&bic=${bic}`;
		let url = this.serviceUrl + `/iban/validate?iban=${iban}`;
    return this.opencellAPI.callApi(url);
	}

  createPaymentMethod(paymentMethod) {
		const url = this.serviceUrl + "/payment/paymentMethod";
		return this.opencellAPI.invokeRequest(paymentMethod, url, "POST");
	}

  updatePaymentMethod(paymentMethod) {
		const url = this.serviceUrl + "/payment/paymentMethod";
		return this.opencellAPI.invokeRequest(paymentMethod, url, "PUT");
	}

  deletePaymentMethod(id) {
		const url = this.serviceUrl + "/payment/paymentMethod?id="+ id;
		return this.opencellAPI.invokeRequest(id, url, "DELETE")
  }

  rumSequences() {
    const url = this.serviceUrl + "/payment/rumSequences/nextMandateNumber";
    return this.opencellAPI.invokeRequest({}, url, "POST")
  }

  checkMandate(mondatReference,{code}) {
    let url = this.serviceUrl + `/payment/paymentGateway/checkMandate?mandateReference=${mondatReference}&customerAccountCode=${code}`
    return this.opencellAPI.callApi(url);
  }

  approveSepaDDMandate({code}) {
    let url = this.serviceUrl + `/payment/paymentGateway/approveSepaDDMandate?&customerAccountCode=${code}`
    return this.opencellAPI.callApi(url);
  }

  addPayment(payload) {
		let url = this.serviceUrl +`/v2/generic/paymentMethod/`;
		return this.opencellAPI.invokeRequest(
			payload,
			url,
			"POST"
		);
	}

  getHostedCheckout(ca, seller, amount, returnUrl) {
		let url = this.serviceUrl + `/payment/paymentGateway/getHostedCheckoutUrl?ca=${ca}&returnUrl=${returnUrl}&seller=${seller}&amount=${amount}`
		return this.opencellAPI.callApi(url);
	}

  getHostedCheckoutStatus(ca, seller, pageID) {
		let url = this.serviceUrl + `/payment/paymentGateway/getHostedCheckoutStatus?ca=${ca}&seller=${seller}&id=${pageID}`
		return this.opencellAPI.callApi(url);
	}
}

const paymentService = new PaymentService();

export default paymentService;



// WEBPACK FOOTER //
// ./src/opencell/services/PaymentService.js